export default __webpack_public_path__ + "static/media/789.cfc62bcd.png";